import { FunctionComponent } from 'react'
import { CardContentGrid, CollapsibleCard } from '@black-bear-energy/rucksack'
import { CardContentField } from './CardContentField'
import { SiteRFPDetails } from '@black-bear-energy/black-bear-energy-common'
import { formatTableDate } from '../helpers/formatTableDate'
import { ConstructionStatusChip } from '../common/ConstructionStatusChip'

export const ConstructionDetailsCard: FunctionComponent<
  ConstructionDetailsCardProps
> = ({ siteRFPDetails, isFetching }) => {
  return (
    <CollapsibleCard
      title="Construction Details"
      titleAdornment={
        siteRFPDetails?.constructionStatus ? (
          <ConstructionStatusChip status={siteRFPDetails.constructionStatus} />
        ) : undefined
      }
    >
      <CardContentGrid columns={3}>
        <CardContentField
          label="Construction Start"
          value={
            siteRFPDetails?.constructionStartDate
              ? formatTableDate(siteRFPDetails.constructionStartDate)
              : null
          }
          isFetching={isFetching}
        />
        <CardContentField
          label="Mechanical Completion"
          value={
            siteRFPDetails?.mechanicalCompleteDate
              ? formatTableDate(siteRFPDetails.mechanicalCompleteDate)
              : null
          }
          isFetching={isFetching}
        />
        <CardContentField
          label="Permission to Operate (PTO)"
          value={
            siteRFPDetails?.ptoDate
              ? formatTableDate(siteRFPDetails.ptoDate)
              : null
          }
          isFetching={isFetching}
        />
      </CardContentGrid>
    </CollapsibleCard>
  )
}

export interface ConstructionDetailsCardProps {
  siteRFPDetails?: SiteRFPDetails | null
  isFetching: boolean
}
